/**
 * Endless HUD's "BEST" display rule: while the current run's Length is
 * below the stored record, show the stored record; once the current run
 * actually exceeds it, show the live current Length as the (not-yet-
 * persisted) best - see `EndlessStorage`'s comparator for the real
 * persistence rule, which only ever runs once at a genuine terminal
 * result, never here. `storedBestLength` is `null` when no record has
 * ever been saved yet, in which case the current run's own Length is
 * always shown (there is nothing else to compare against).
 */
export function computeDisplayedBestLength(storedBestLength: number | null, currentLength: number): number {
  return storedBestLength === null ? currentLength : Math.max(storedBestLength, currentLength);
}
